export const Colors = {
    bg1: "#1C1D26",
    bg2: "#252632",
    bg3: "#656986",
    bgOverlayColor: "#8294C4",
    txt1: "#F4F4F4",
    link1: "#9DA5F3",
};
